import { AxiosError } from "axios";
import { useState } from "react";
import { useMutation, UseMutationResult } from "react-query";
import { ExecutionSteps, ConfType } from "../types";
import axiosClient from "../utils/axiosClient";

export const useStartAnalysisByFileMutation = (
  cb: (err: boolean, msg?: string) => void
): [
  UseMutationResult<
    string,
    AxiosError<{
      msg: string;
    }>,
    {
      confName: string;
      sessionName: string;
      file: FileList[0];
      steps?: ExecutionSteps[];
      type: ConfType;
    },
    any
  >,
  number
] => {
  const [progress, setProgress] = useState(0);

  const mutation = useMutation<
    string,
    AxiosError<{ msg: string }>,
    {
      confName: string;
      sessionName: string;
      file: FileList[0];
      steps?: ExecutionSteps[];
      type: ConfType;
    },
    any
  >(
    ({ confName, sessionName, file, steps, type }) => {
      setProgress(0);
      const formData = new FormData();
      formData.set("confName", `${confName}`);
      formData.set("sessionName", `${sessionName}`);
      formData.set("type", type);
      formData.append("file", file);
      if (steps) {
        formData.append("steps", JSON.stringify(steps));
      }

      return axiosClient
        .post("/analysis/start/byFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        })
        .then(({ data }) => data);
    },
    {
      onError: ({ response }) => {
        if (response?.data.msg) {
          cb(true, response.data.msg);
        } else {
          cb(true, "Something went wrong.");
        }
      },
      onSuccess: async () => {
        cb(false);
      },
    }
  );
  return [mutation, progress];
};
